import axiosInstance from "../axiosInstance";

export const fetchVehicleById = async (id) => {
    if (!id) throw new Error("vehId requerido");
    const response = await axiosInstance.get(`/vehicles/${id}`);
    return response.data;
};